
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tarms",
      function () {
        return require("private-next-pages/tarms/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tarms"])
      });
    }
  